export default __webpack_public_path__ + "static/media/bsctestnet.840321d8.png";